import { SearchAccountForm } from 'core/cuenta/components/SearchAccountForm/SearchAccountForm';
import { SearchAccountFormData } from 'core/cuenta/models/SearchAccountFormData';
import { ACCOUNT_TOTALS_PATH } from 'core/cuenta/routes';
import { CARDS_TOTALS_BY_ACCOUNT_PATH } from 'core/tarjeta/routes';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatParams } from 'shared/utils';

export const SearchAccountTotalsPage = (props: { isPrevious?: boolean }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const isPrevious = !!props.isPrevious;

  const performSearch = (data: SearchAccountFormData) => {
    let params;
    if (data.selectdate != null) {
      params = data.selectdate;
    }
    if (data.option === 'totals') {
      navigate({
        pathname: ACCOUNT_TOTALS_PATH,
        search: formatParams(params),
      });
    } else {
      navigate({
        pathname: CARDS_TOTALS_BY_ACCOUNT_PATH.replace(':accountNumber', data.cuenta),
        search: formatParams(params),
      });
    }
  };
  return (
    <Container>
      <Row>
        <Col>
          <SearchAccountForm
            performSearch={performSearch}
            defaultAccountNumber={state && state['accountNumber']}
            isPrevious={isPrevious}
          />
        </Col>
      </Row>
    </Container>
  );
};
